import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';
import {
  PageableFilter,
  PageableRequest,
  ShippingOrderControllerService,
  ShippingOrderDetail
} from 'src/app/admin-api';
import {
  DropdownFilter,
  PageContent,
  TableColumn,
  TableComponent
} from '../table';

@Component({
  selector: 'app-person-movements',
  templateUrl: './person-movements.component.html',
  styleUrls: ['./person-movements.component.scss']
})
export class PersonMovementsComponent implements OnInit {
  @ViewChild(TableComponent)
  table: TableComponent;

  @Input()
  personId = 0;

  public shippingOrderService = inject(ShippingOrderControllerService);

  cols = [
    new TableColumn.Builder()
      .setHeader('Id')
      .setField('shippingOrderId')
      .setRouterLink('/products/shipping-orders/')
      .setRouterLinkFieldName('shippingOrderId')
      .build(),
    new TableColumn(
      'Tipo',
      'shippingOrderTypeName',
      true,
      'text',
      undefined,
      undefined,
      true,
      'equals'
    ),
    new TableColumn(
      'Data',
      'dateCreated',
      true,
      'date',
      undefined,
      undefined,
      true,
      'between'
    ),
    new TableColumn('Produtos', 'items', false, 'formattedInteger'),
    new TableColumn.Builder()
      .setHeader('Status')
      .setField('shippingOrderStatusName')
      .build(),
    new TableColumn.Builder()
      .setHeader('Prazo entrega')
      .setField('maxDeliveryDate')
      .setType('date')
      .setCondition('between')
      .build(),
    new TableColumn.Builder()
      .setHeader('Status Millennium')
      .setField('statusMillennium')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Últ. Atualização Millennium')
      .setField('dateUpdatedMillennium')
      .setCondition('between')
      .setType('date')
      .build(),
    new TableColumn.Builder()
      .setHeader('Data entrega')
      .setField('finalDeliveryDate')
      .setCondition('between')
      .setType('date')
      .build(),
    new TableColumn.Builder()
      .setHeader('Motivo brinde')
      .setField('referenceName')
      .setCondition('contains')
      .build()
  ];
  dropdownFilters = {};
  fixedFilters: Array<PageableFilter> | undefined;

  ngOnInit() {
    this.findShippingOrderTypes().then();
    this.findShippingOrderStatusList().then();
    this.fixedFilters = [
      {
        condition: 'equals',
        field: 'personId',
        value: this.personId?.toString(),
        fieldType: 'number'
      }
    ];
  }

  async findPage(
    request: PageableRequest,
    service: unknown
  ): Promise<PageContent<ShippingOrderDetail>> {
    const type = request.filters?.find(
      (f) => f.field === 'shippingOrderTypeName'
    );
    if (type?.value) {
      request.filters?.push({
        condition: 'equals',
        field: 'shippingOrderTypeId',
        fieldType: 'number',
        value: Number(type.value)
      });
    }
    return lastValueFrom(
      (service as ShippingOrderControllerService)
        .getShippingOrdersTable(request)
        .pipe(map((data) => data.result as PageContent<ShippingOrderDetail>))
    );
  }

  async findShippingOrderTypes(): Promise<void> {
    this.dropdownFilters['shippingOrderTypeName'] = await lastValueFrom(
      this.shippingOrderService
        .getShippingOrderTypes()
        .pipe(
          map((data) =>
            [{ label: 'Todos', value: null } as DropdownFilter].concat(
              data.result
            )
          )
        )
    );
  }

  async findShippingOrderStatusList(): Promise<void> {
    this.dropdownFilters['shippingOrderStatusName'] = await lastValueFrom(
      this.shippingOrderService.getShippingOrderStatusList().pipe(
        map((data) =>
          [{ label: 'Todos', value: null } as DropdownFilter].concat(
            data.result.map(
              (status) =>
                ({
                  label: status.shippingOrderStatusName,
                  value: status.shippingOrderStatusId
                }) as DropdownFilter
            )
          )
        )
      )
    );
  }
}
